import React from 'react';
import { MainLayout } from '@/components/layout/MainLayout';
import { EmptyState } from '@/components/ui/EmptyState';
import { Compass } from 'lucide-react';
import { ROUTES } from '@/lib/constants';
import { PLACEHOLDER } from '@/constants/testIds';

export default function NotFound() {
  return (
    <MainLayout>
      <section className="py-20 sm:py-28">
        <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-10">
            <span className="font-display ns-text-gradient-gold text-7xl sm:text-9xl tracking-tight">
              404
            </span>
          </div>
          <EmptyState
            icon={Compass}
            title="Página fuera de juego"
            description="La página que buscas no existe o ha sido movida. Vuelve al inicio y descubre lo que NetScouters tiene preparado."
            primaryAction={{
              label: 'Volver al inicio',
              to: ROUTES.home,
              testId: PLACEHOLDER.backHome,
            }}
          />
        </div>
      </section>
    </MainLayout>
  );
}
